import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationComponent } from './navigation/navigation.component';
import { StepAccountComponent } from './step-account/step-account.component';
import { StepTariffComponent } from './step-tariff/step-tariff.component';
import { StepPersonalComponent } from './step-personal/step-personal.component';
import { SoftNoteTaxComponent } from './soft-note-tax/soft-note-tax.component';
import { StepInvoiceComponent } from './step-invoice/step-invoice.component';
import { SoftNoteFeeComponent } from './soft-note-fee/soft-note-fee.component';
import { StepContractComponent } from './step-contract/step-contract.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    imports: [NavigationComponent, StepAccountComponent, StepTariffComponent, StepPersonalComponent, SoftNoteTaxComponent, StepInvoiceComponent, SoftNoteFeeComponent, StepContractComponent, FooterComponent]
})
export class RegisterComponent {

    constructor(private translate: TranslateService) {
    }

}
